
const LoanApprovalEstimateDisclaimer = (props) => {
    return (
        <p className='ts-disclaimer des-disclaimer'>
            <span dangerouslySetInnerHTML={{ __html: props.Disclaimer }} />
        </p>
    );
};

export default LoanApprovalEstimateDisclaimer;